import {useTranslation} from "react-i18next";

export const TextInputReadOnly = (props) => {
    const {
        type = 'text',
        translationIndex = null,
        value
    } = props;
    const {t} = useTranslation();

    const randomName = Math.random().toString(36).substring(7);

    return (
        <div className={'my-4'}>
            {
                translationIndex !== null && (
                    <label htmlFor={randomName}
                           className="block text-left text-sm font-medium leading-6 text-gray-900 select-none">
                        {t(`${translationIndex}`)}
                    </label>
                )
            }
            <div className="relative rounded-md shadow-sm">
                <div
                    name={randomName}
                    type={type}
                    className={`bg-gray-200 block select-none w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6`}
                >
                    {value}
                </div>
            </div>
        </div>
    )
}